import * as React from 'react'
import * as ReactDOM from 'react-dom'
import EventListBlock from './components/main/event-list-block'
/*
1. get the elements with the class
2. loop in the elements and render the block for each one
*/

const elements = document.getElementsByClassName('nacd-layout-left-side print-hide');

//convert HTMLCollection to array
const elementsArray = Array.from(elements);

elementsArray.forEach((element) => {
    const domContainer = element;
    const pageID = (domContainer.querySelector('.page-id') as HTMLInputElement).value;
    ReactDOM.render(<EventListBlock pageID={pageID}/>, domContainer);
});

